<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 270px">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>類別：</td>
                  <td>
                    <select v-model="form.posT_NODE">
                      <option value="0">首頁</option>
                      <option value="1">申報端</option>
                      <option value="2">管理端</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>公告標題：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.title" />
                  </td>
                </tr>
                <tr>
                  <td>上線期間：</td>
                  <td>
                    <DatePicker
                      v-model="form.starT_DATE"
                      format="YYYMMDD"
                      :isTaiwanYear="true"
                      :disabled-date="disabledStartDate"
                      clearable
                      placeholder="請輸入/選擇日期"
                    />
                    至
                    <DatePicker
                      v-model="form.enD_DATE"
                      format="YYYMMDD"
                      :isTaiwanYear="true"
                      :disabled-date="disabledEndDate"
                      clearable
                      placeholder="請輸入/選擇日期"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.pagesize = 10;
                          this.form.currentpage = 1;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information">
      <table width="100%">
        <tbody>
          <tr>
            <td></td>
            <td v-if="grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th colspan="2">操作</th>
                <th style="min-width: 80px">公告標題</th>
                <th style="min-width: 80px">上線狀態</th>
                <th style="width: 200px">上線期間</th>
              </tr>
            </thead>
            <tbody
              v-if="
                Object.keys(grid).length &&
                grid.gridDatas &&
                grid.gridDatas.length > 0
              "
            >
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnEdit(data)"
                    value="編"
                  />
                </td>
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnDelete(data)"
                    value="刪"
                  />
                </td>
                <td>{{ data.title }}</td>
                <td>{{ data.posT_TYPE == "1" ? "永久" : "區間" }}</td>
                <td>
                  {{
                    $moment(data.starT_DATE).format("YYYY") -
                    1911 +
                    $moment(data.starT_DATE).format("MMDD")
                  }}
                  ~
                  {{
                    data.enD_DATE
                      ? $moment(data.enD_DATE).format("YYYY") -
                        1911 +
                        $moment(data.enD_DATE).format("MMDD")
                      : ""
                  }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" style="text-align: center">查無資料</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 查詢結果結束-->
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>類別</td>
                <td colspan="3">
                  <select v-model="DetailModal.form.posT_NODE">
                    <option value="0">首頁</option>
                    <option value="1">申報端</option>
                    <option value="2">管理端</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>公告標題</td>
                <td colspan="3">
                  <input
                    type="text"
                    v-model="DetailModal.form.title"
                    size="80"
                    maxlength="80"
                  />
                </td>
              </tr>
              <tr>
                <td>公告日期</td>
                <td colspan="3">
                  <DatePicker
                    v-model="DetailModal.form.posT_DATE"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                  <!-- :disabled-date="disabledDetailPostDate" -->
                </td>
              </tr>
              <tr>
                <td style="width: 10%">內容</td>
                <td colspan="3">
                  <ckeditor
                    :config="CkeditorConfig"
                    :editor="editor"
                    v-model="DetailModal.form.content"
                  ></ckeditor>
                </td>
              </tr>
              <tr>
                <td>上線期間</td>
                <td colspan="3">
                  <input
                    type="radio"
                    name="RadioGroup1"
                    value="1"
                    v-model="DetailModal.form.posT_TYPE"
                    checked="checked"
                  />永久
                  <input
                    type="radio"
                    name="RadioGroup1"
                    value="2"
                    v-model="DetailModal.form.posT_TYPE"
                  />區間
                  <DatePicker
                    v-model="DetailModal.form.starT_DATE"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    :disabled-date="disabledDetailStartDate"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                  至
                  <DatePicker
                    v-model="DetailModal.form.enD_DATE"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    :disabled-date="disabledDetailEndDate"
                    clearable
                    placeholder="請輸入/選擇日期"
                    :disabled="DetailModal.form.posT_TYPE == 1"
                  />
                </td>
              </tr>
              <tr>
                <td>附件</td>
                <td>
                  <input type="file" @change="ImportModalOnFileChange" />
                  <input
                    type="submit"
                    class="btn"
                    value="加入"
                    @click="ImportModalBtnImport()"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="active">
                    <div class="table_scroll2">
                      <table width="860" class="itable">
                        <thead>
                          <tr>
                            <th style="min-width: 80px">操作</th>
                            <th style="min-width: 80px">檔名</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in DetailModal.form
                              .LISTPOSTCNT"
                            :key="index"
                          >
                            <td width="1%" align="center">
                              <input
                                type="button"
                                class="btn"
                                @click="btnFileDelete(data)"
                                value="刪"
                              />
                            </td>
                            <td>
                             <a
                                :href="
                                  'data:' +
                                  data.attR_TYPE +
                                  ';base64,' +
                                  data.attR_STRING
                                "
                                :download="data.attR_NAME"
                              >
                                {{ data.attR_NAME }}
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnDetailSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnDetailClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor';
// import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
// import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily';
// import FontSize from '@ckeditor/ckeditor5-font/src/fontsize';

import { getMenuIndex, getMenu } from "@/config/util.js";
import {
  S402_SearchGrid,
  S402_Delete,
  S402_Detail,
  S402_DetailAddSave,
  S402_DetailEditSave,
} from "@/service/api.js";
export default {
  name: "S402",
  data: function () {
    return {
      editor: ClassicEditor,
      // Classic 樣式
      CkeditorConfig: {
        // 客製化設定
        toolbar: {
          items: [
            "bold",
            "italic",
            "|",
            "undo",
            "redo",
            "numberedList",
            "bulletedList",
          ],
          // 設定工具列，可使用'|'隔開功能
        },
        // fontColor: {
        //     colors: [
        //         {
        //             color: 'hsl(0, 0%, 0%)',
        //             label: 'Black'
        //         },
        //         {
        //             color: 'hsl(0, 0%, 30%)',
        //             label: 'Dim grey'
        //         },
        //         {
        //             color: 'hsl(0, 0%, 60%)',
        //             label: 'Grey'
        //         },
        //         {
        //             color: 'hsl(0, 0%, 90%)',
        //             label: 'Light grey'
        //         },
        //         {
        //             color: 'hsl(0, 0%, 100%)',
        //             label: 'White',
        //             hasBorder: true
        //         },
        //     ]
        // },
        // FontBackgroundColor: {
        //     colors: [
        //         {
        //             color: 'hsl(0, 75%, 60%)',
        //             label: 'Red'
        //         },
        //         {
        //             color: 'hsl(30, 75%, 60%)',
        //             label: 'Orange'
        //         },
        //         {
        //             color: 'hsl(60, 75%, 60%)',
        //             label: 'Yellow'
        //         },
        //         {
        //             color: 'hsl(90, 75%, 60%)',
        //             label: 'Light green'
        //         },
        //         {
        //             color: 'hsl(120, 75%, 60%)',
        //             label: 'Green'
        //         },
        //     ]
        // },
        // plugins: [
        //FontColor,
        // FontBackgroundColor,
        // FontSize,
        // ],

        // fontSize: {
        //     options: [
        //         9,
        //         11,
        //         13,
        //         'default',
        //         17,
        //         19,
        //         21
        //     ]
        // },
        placeholder: "",
        // 當編輯器內容為空時顯示此字串
        initialData: "",
        // 初始化載入文字
        language: "zh",
        // 設定語言
      },
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S402",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        posT_NODE: "0",
        title: "",
        content: "",
        starT_DATE: "",
        enD_DATE: "",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        syears: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "S402 公告維護",
        form: {
          pkno: "",
          title: "",
          content: "",
          //公告單位(0.共用 1.法務部 2.監察院)
          posT_DEPT: "1",
          //公告類別(1.永久 2.區間)
          posT_TYPE: "1",
          //公告網站(0.首頁 1.申報端 2.管理端)
          posT_NODE: "0",
          posT_DATE: "",
          starT_DATE: "",
          enD_DATE: "",
          sort: 1,
          LISTPOSTCNT: [],
          file: {
            attR_NAME: "",
            attR_TYPE: "",
            attR_STRING: "",
          },
          file1:"",
          uploadFile: [],
          userid: "", //self.loginInfo.id,
        },
        modifyType: "", //"I,U"
        dropDownList: {
          syears: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    DetailModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    ExportModalGetSyearDropDownList: function () {
      let syears = [];
      for (
        let i = new Date().getFullYear() - 1911;
        i > new Date().getFullYear() - 1911 - 4;
        i--
      ) {
        syears.push(i.toString());
      }
      return syears;
    },
    GetSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    disabledStartDate: function (time) {
      if (this.form.enD_DATE) {
        return time > this.form.enD_DATE;
      }
      return false;
    },
    disabledEndDate: function (time) {
      if (this.form.starT_DATE) {
        return time < this.form.starT_DATE;
      }
      return false;
    },
    // disabledDetailPostDate: function(time){
    //   return this.$moment(time).isBefore(this.$moment(this.$moment().format("YYYYMMDD"))._d);
    // },
    disabledDetailStartDate: function (time) {
      // if(this.$moment(time).isBefore(this.$moment(this.$moment().format("YYYYMMDD"))._d)) return true;
      if (this.DetailModal.form.enD_DATE) {
        return time > this.DetailModal.form.enD_DATE;
      }
      return false;
    },
    disabledDetailEndDate: function (time) {
      // if(this.$moment(time).isBefore(this.$moment(this.$moment().format("YYYYMMDD"))._d)) return true;
      if (this.DetailModal.form.starT_DATE) {
        return time < this.DetailModal.form.starT_DATE;
      }
      return false;
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        posT_NODE: self.form.posT_NODE,
        title: self.form.title,
        starT_DATE: self.form.starT_DATE,
        enD_DATE: self.form.enD_DATE,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S402_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    doClear: function () {
      this.form = {
        posT_NODE: "0",
        title: "",
        content: "",
        starT_DATE: "",
        enD_DATE: "",
        pagesize: 10,
        currentpage: 1,
      };
    },
    //取消
    btnCancelCheck: function () {
      const self = this;
      self.form.Selected = [];
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.PreData = {};
      self.btnDetailClear();
      self.DetailModalInit();
      self.DetailModal.modifyType = "I";
      self.DetailModal.form.uploadFile = [];
      self.DetailModal.form.LISTPOSTCNT = [];
      self.DetailModal.form.posT_NODE = self.form.posT_NODE;
      self.DetailModal.title = "S402 公告維護-新增";
      self.DetailModal.show = true;
    },
    //第一頁匯入
    btnImport: function () {
      const self = this;
      self.ImportModal.show = true;
    },
    //gird
    //第一頁編
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.getDetailData();
      self.DetailModalInit();
      self.DetailModal.modifyType = "U";
      self.DetailModal.title = "S402 公告維護-編輯";
      self.DetailModal.show = true;
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      S402_Delete({
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: data.pkno,
        PostSeq: data.posT_SEQ,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第一頁整批刪除按紐
    btnDeleteAll: function () {
      const self = this;
      if (self.form.Selected.length) {
        self.grid.gridDatas.forEach((g) => self.btnDelete({ pkno: g.pkno }));
        //self.modal.show = true;
        //self.btnModalClear();
        //self.modalGetOnJob();
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先勾選移轉名單!"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }
    },
    //第二頁明細init
    DetailModalInit: function () {
      const self = this;
      self.GetSyearDropDownList();
    },
    //第二頁明細內容 API
    getDetailData: function () {
      const self = this;
      S402_Detail({
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: self.DetailModal.PreData.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.DetailModal.grid = rData.returnObject;
          self.DetailModal.form = {
            posT_SEQ: self.DetailModal.grid.posT_SEQ,
            posT_TYPE: self.DetailModal.grid.posT_TYPE,
            posT_DEPT: self.DetailModal.grid.posT_DEPT,
            posT_NODE: self.DetailModal.grid.posT_NODE,
            title: self.DetailModal.grid.title,
            content: self.DetailModal.grid.content,
            posT_DATE: self.DetailModal.grid.posT_DATE,
            starT_DATE: self.DetailModal.grid.starT_DATE,
            enD_DATE: self.DetailModal.grid.enD_DATE,
            sort: self.DetailModal.grid.sort,
            pkno: self.DetailModal.grid.pkno,
            uploadFile:[],
            LISTPOSTCNT: self.DetailModal.grid.listpostcnt,
            userid: "", //self.loginInfo.id,
          };
        }
      });
    },
    //明細防呆
    DetailValidation: function () {
      const self = this;
      const msg = [];
      if (!self.DetailModal.form.posT_NODE) msg.push("請填寫類別");
      if (self.DetailModal.form.title.trim() == "") msg.push("請填寫公告標題");
      if (!self.DetailModal.form.posT_DATE) msg.push("請填寫公告日期");
      if (self.DetailModal.form.content.trim() == "") msg.push("請填寫內容");
      if (!self.DetailModal.form.starT_DATE) msg.push("請填寫上線期間起日");
      if (self.DetailModal.form.posT_TYPE == "2") {
        if (!self.DetailModal.form.enD_DATE) {
          msg.push("請填寫上線期間迄日");
        } else {
          if (
            self
              .$moment(self.DetailModal.form.enD_DATE)
              .isBefore(self.DetailModal.form.starT_DATE)
          )
            msg.push("上線期間迄日需大於上線期間起日");
        }
      }
      if (msg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第二頁明細新增 API
    S402_DetailAddSave: function () {
      const self = this;
      if (!self.DetailValidation()) return;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        posT_SEQ: self.DetailModal.form.posT_SEQ,
        posT_DEPT: self.DetailModal.form.posT_DEPT,
        posT_NODE: self.DetailModal.form.posT_NODE,
        title: self.DetailModal.form.title,
        content: self.DetailModal.form.content,
        posT_DATE: self.DetailModal.form.posT_DATE,
        starT_DATE: self.DetailModal.form.starT_DATE,
        enD_DATE: self.DetailModal.form.enD_DATE,
        sort: self.DetailModal.form.sort,
        posT_TYPE: self.DetailModal.form.posT_TYPE,
        LISTPOSTCNT: self.DetailModal.form.LISTPOSTCNT,
        pkno: 0,
        userid: "", //self.loginInfo.id,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      let formData = new FormData();
      for (var i = 0; i !== self.DetailModal.form.uploadFile.length; i++) {
        formData.append("UPDLOAD_FILE", self.DetailModal.form.uploadFile[i]);
      }
      formData.append("ServiceUnit", self.pageData.ServiceUnit);
      formData.append("posT_SEQ", self.DetailModal.form.posT_SEQ);
      formData.append("posT_DEPT", self.DetailModal.form.posT_DEPT);
      formData.append("posT_NODE", self.DetailModal.form.posT_NODE);
      formData.append("title", self.DetailModal.form.title);
      formData.append("content", self.DetailModal.form.content);
      formData.append("posT_DATE", self.$moment(self.DetailModal.form.posT_DATE).format("YYYY/MM/DD"));
      formData.append("starT_DATE", self.$moment(self.DetailModal.form.starT_DATE).format("YYYY/MM/DD"));
      formData.append("enD_DATE", self.DetailModal.form.enD_DATE == "" || self.DetailModal.form.enD_DATE == null ? "":self.$moment(self.DetailModal.form.enD_DATE).format("YYYY/MM/DD"));
      formData.append("sort", self.DetailModal.form.sort);
      formData.append("posT_TYPE", self.DetailModal.form.posT_TYPE);
      formData.append("pkno", 0);
      formData.append("userid", "");
      formData.append("LogInfo.Id", self.loginInfo.id);
      formData.append("LogInfo.PrgCode", self.pageData.PrgName);
      formData.append("LogInfo.Token", self.loginInfo.token);
      formData.append("LogInfo.ActCd", "第二頁明細新增");
      formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
      S402_DetailAddSave(formData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["新增失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第二頁明細修改 API
    S402_DetailEditSave: function () {
      const self = this;
      if (!self.DetailValidation()) return;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        pkno: self.DetailModal.PreData.pkno,
        posT_SEQ: self.DetailModal.form.posT_SEQ,
        posT_DEPT: self.DetailModal.form.posT_DEPT,
        posT_NODE: self.DetailModal.form.posT_NODE,
        title: self.DetailModal.form.title,
        content: self.DetailModal.form.content,
        posT_DATE: self.DetailModal.form.posT_DATE,
        starT_DATE: self.DetailModal.form.starT_DATE,
        enD_DATE: self.DetailModal.form.enD_DATE,
        sort: self.DetailModal.form.sort,
        posT_TYPE: self.DetailModal.form.posT_TYPE,
        LISTPOSTCNT: self.DetailModal.form.LISTPOSTCNT,
        userid: "", //self.loginInfo.id
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      let formData = new FormData();
      for (var i = 0; i !== self.DetailModal.form.uploadFile.length; i++) {
        formData.append("UPDLOAD_FILE", self.DetailModal.form.uploadFile[i]);
      }
      formData.append("ServiceUnit", self.pageData.ServiceUnit);
      formData.append("posT_SEQ", self.DetailModal.form.posT_SEQ);
      formData.append("posT_DEPT", self.DetailModal.form.posT_DEPT);
      formData.append("posT_NODE", self.DetailModal.form.posT_NODE);
      formData.append("title", self.DetailModal.form.title);
      formData.append("content", self.DetailModal.form.content);
     formData.append("posT_DATE", self.$moment(self.DetailModal.form.posT_DATE).format("YYYY/MM/DD"));
      formData.append("starT_DATE", self.$moment(self.DetailModal.form.starT_DATE).format("YYYY/MM/DD"));
      formData.append("enD_DATE", self.DetailModal.form.enD_DATE == "" || self.DetailModal.form.enD_DATE == null  ? "":self.$moment(self.DetailModal.form.enD_DATE).format("YYYY/MM/DD"));
      formData.append("sort", self.DetailModal.form.sort);
      formData.append("posT_TYPE", self.DetailModal.form.posT_TYPE);
      formData.append("pkno", self.DetailModal.PreData.pkno);
      formData.append("userid", "");
      formData.append("LogInfo.Id", self.loginInfo.id);
      formData.append("LogInfo.PrgCode", self.pageData.PrgName);
      formData.append("LogInfo.Token", self.loginInfo.token);
      formData.append("LogInfo.ActCd", "第二頁明細修改");
      formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
      S402_DetailEditSave(formData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["修改失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      if (self.DetailModal.modifyType == "I") {
        self.S402_DetailAddSave();
      } else if (self.DetailModal.modifyType == "U") {
        self.S402_DetailEditSave();
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.DetailModal.form = {
        posT_DEPT: "1",
        posT_NODE: "",
        posT_SEQ: "",
        title: "",
        content: "",
        starT_DATE: "",
        enD_DATE: "",
        sort: 1,
        posT_TYPE: "1",
        LISTPOSTCNT: self.DetailModal.form.LISTPOSTCNT,
        file: {
          attR_NAME: "",
          attR_TYPE: "",
          attR_STRING: "",
        },
        file1: "",
        uploadFile: [],
      };
    },
    //匯入頁
    ImportModalOnFileChange: function (event) {
      const self = this;
      let file = event.target.files[0];
      self.DetailModal.form.file = {
        attR_NAME: file.name,
        attR_TYPE: file.type,
        attR_STRING: "",
      };
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.DetailModal.form.file.attR_TYPE = reader.result.split(",")[0];
        self.DetailModal.form.file.attR_STRING = reader.result.split(",")[1];
        console.log(reader.result);
      };
      self.DetailModal.form.file1 =  file;
      reader.onerror = function (error) {
        console.log("申報資料上傳檔案錯誤: ", error);
      };
    },
    //匯入頁 按紐加入
    ImportModalBtnImport: function () {
      const self = this;
      if (
        self.DetailModal.form.file.attR_NAME &&
        self.DetailModal.form.file.attR_TYPE &&
        self.DetailModal.form.file.attR_STRING
      ) {
        self.DetailModal.form.LISTPOSTCNT.push(self.DetailModal.form.file);
        self.DetailModal.form.uploadFile.push(self.DetailModal.form.file1);
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請上傳檔案!!"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }
    },
    //匯入頁 檔案刪
    btnFileDelete: function (data) {
      const self = this;
      self.DetailModal.form.LISTPOSTCNT =
        self.DetailModal.form.LISTPOSTCNT.filter(
          (x) => x.attR_NAME != data.attR_NAME
        );
      //console.log(data);
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.GetSyearDropDownList();
    self.doQuery();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "DetailModal.form.posT_TYPE": function (newValue) {
      if (newValue == "1") this.DetailModal.form.enD_DATE = "";
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
<style>
.ck-editor__editable {
  min-height: 200px !important;
}
</style>


